import ToolingLocationSearch from './ToolingLocationSearch';
import ToolingLocationSearchHOC from './ToolingLocationSearchHOC';

export default ToolingLocationSearchHOC(ToolingLocationSearch);



// WEBPACK FOOTER //
// ./src/components/ToolingLocations/ToolingLocationsSearch/index.jsx